import { render } from "./AddRevisionTecnica.vue?vue&type=template&id=da696072"
import script from "./AddRevisionTecnica.vue?vue&type=script&lang=js"
export * from "./AddRevisionTecnica.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__